import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelHeader } from "../../../../../components/Panel/PanelHeader";
import { Panel, TextField } from "@fluentui/react";
import { MessageBarResponse } from "../../../../../components/MessageBarResponse/MessageBarResponse";
import { ProgressBarLoading } from "../../../../../components/ProgressBarLoading/ProgressBarLoading";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { ComboBoxComponent } from "../../../../../components/comboBox/ComboBoxComponent";
import { UsePanelRazonInsertar } from "./usePanelRazonInsertar";
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic";

export interface IPanelRazonInsertar extends IOpenPanel{

}
export const PanelRazonInsertar=(props:IPanelRazonInsertar)=>{
    const {request,setRequest,postInsertarRazon,loading,disableForm,reset,mensaje,status,estados,categorias} =UsePanelRazonInsertar(props)
    const onRenderHeader = useCallback(
        () => (
            <PanelHeaderBasic
              subTextHeader=""
              textHeader="Agregar Razón"
            />
        ),
        []
    );

    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={postInsertarRazon}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [disableForm,request]
      );
    return (
        <Panel
        isOpen={props.isOpen}
        onDismiss={reset}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom
        onRenderHeader={onRenderHeader}
        >
        <div hidden={mensaje == ""}>
        <MessageBarResponse
          objetoResponse={{ codigo: status, mensaje: mensaje }}
          close={true}
        />
      </div>
      <div hidden={!loading}>
        <ProgressBarLoading></ProgressBarLoading>
      </div>
      <div hidden={loading}>
      {!mensaje && (
        <>
      <TextField 
         type="text"
         label="Nombre de Razón"
         placeholder="Ingrese Nombre de Razón"
         autoComplete="off"
         value={request.codigo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,codigo:newValue})}
         }}
         />
         <br/>
        <TextField 
         type="text"
         label="Descripción de Razón"
         placeholder="Ingrese Descripción de Razón"
         autoComplete="off"
         value={request.descripcion}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,descripcion:newValue})}
         }}
         />
         <ComboBoxComponent text={"Estado"} placeholder="Seleccione Estado" data={estados} onOptionSelect={(event,option)=>{
          if(option ){
            setRequest({...request,estadoId:String(option.key)})
          }
         }}></ComboBoxComponent>
          <ComboBoxComponent text={"Categoria"} placeholder="Seleccione Categoria" data={categorias} onOptionSelect={(event,option)=>{
          if(option ){
            setRequest({...request,categoriaId:String(option.key)})
          }
         }}></ComboBoxComponent>
         </>)}

      </div>

    </Panel>)

}